import { StyleSheet } from 'react-native';
import { WHITE, tokens, LILAC_200, TRANSPARENT } from '@airtel/air-design-system';
var borderLeftRightWidth = {
  borderLeftWidth: tokens.spacing.SPACING_1,
  borderRightWidth: tokens.spacing.SPACING_1
};
var borderBottomLeftRightRadius = {
  borderBottomLeftRadius: tokens.spacing.SPACING_16,
  borderBottomRightRadius: tokens.spacing.SPACING_16
};
export var getCollapsibleOfferListWidgetStyles = () => {
  return StyleSheet.create({
    dividerStyle: Object.assign(Object.assign({
      borderColor: WHITE
    }, borderLeftRightWidth), {
      borderTopWidth: tokens.spacing.SPACING_0,
      borderBottomWidth: tokens.spacing.SPACING_0
    }),
    cardTitle: Object.assign(Object.assign({
      backgroundColor: LILAC_200,
      borderColor: WHITE,
      paddingTop: tokens.spacing.SPACING_16,
      paddingBottom: tokens.spacing.SPACING_8
    }, borderLeftRightWidth), {
      borderTopWidth: tokens.spacing.SPACING_1
    }),
    topBorderRadius: {
      borderTopLeftRadius: tokens.spacing.SPACING_16,
      borderTopRightRadius: tokens.spacing.SPACING_16
    },
    bottomBorderRadius: Object.assign({}, borderBottomLeftRightRadius),
    offerListWidget: Object.assign(Object.assign({}, borderBottomLeftRightRadius), {
      borderWidth: tokens.spacing.SPACING_0
    }),
    expandedWidget: {
      marginVertical: tokens.spacing.SPACING_16
    },
    expandSection: {
      marginBottom: tokens.spacing.SPACING_16
    },
    expandCta: {
      alignSelf: 'center',
      marginTop: tokens.spacing.SPACING_16
    },
    payCategoryCardWidget: {
      shadowColor: TRANSPARENT,
      paddingVertical: tokens.spacing.SPACING_8
    },
    collapsibleTitle: {
      flex: 1
    },
    callout: {
      marginTop: tokens.spacing.SPACING_8
    },
    keyPairUnit: {
      backgroundColor: LILAC_200,
      flexDirection: 'column',
      padding: tokens.spacing.SPACING_16
    }
  });
};